export const environment = {
  envName: 'prod',
  app: false,
  mobile: false,
  production: true,
  cinema: 1,
  hidecinema: 0,
  title: "爱壹帆国际版",
  allVip: false, // 所有用户都拥有Vip权限，澳洲用户
  hideAds: false,
  disableNotify: false,//是否关闭通知
  enableAndroidDownload: true,
  enableIOSDonwload: true,
  officialSite: "www.ifsp.tv",
  isDarkModeSupport: true,
  appDownoloadKey: "iyf",
  switchBaseOnTime: false,
  siteKey: "",
  enableContact: true,
  copyRight: "葡萄牙 里斯本 1600-093 Bairro do Rego",
  enableServerDownloadUrl: true, ///是否从服务器端拉取更新版本
  appDownloadLink: "https://www.anygate.vip/r/checkdevice?host=iyf.tv",
  alternativeConfig: [{
    site: "lgsp.tv",
    title: "蓝光视频",
    siteKey: "lgsp.tv",
    enableAndroidDownload: true,
    enableIOSDonwload: true,
    enableContact: true,
    hidecinema: 2,
    hideAds: false,
    copyRight: "西班牙 马德里 13 C. Sta. Florencia",
    enableServerDownloadUrl: false,
    appDownoloadKey: "lgsp",
    appDownloadLink: "https://www.anygate.vip/r/checkdevice?host=lgsp.tv",
    customDownloadInfo: {
      IphoneDownloadURL: "",
      IpadDownloadURL: "",
      AndroidDownloadURL: "https://app.anygate.vip/lgsp",
      IphoneVer: "",
      IpadVer: "",
      AndroidVer: "1.6.1",
      IphoneBak: "",
      IpadBak: "",
      PcDownloadURL: "https://app.anygate.vip/static/lgsp/install.exe?v=2.8.5",
      PcVer: "2.8.5",
      PcMemo: "",
      MacVer: "2.8.5",
      MacDownloadURL:"https://app.anygate.vip/static/lgsp/install.dmg?v=2.8.5",
      MacMemo: "",
      IpadVip: "",
      IphoneVip: "",
      TVDownloadURL: "https://app.anygate.vip/lgsptv",
      TVVer: "2.2.7",
      TVMemo: "2.2.7"
    }

  },
  {
    site: "jssp.tv",
    title: "测试",
    siteKey: "jssp.tv",
    enableAndroidDownload: true,
    enableIOSDonwload: true,
    enableContact: true,
    hidecinema: 2,
    hideAds: false,
    copyRight: "西班牙 马德里 13 C. Sta. Florencia",
    enableServerDownloadUrl: false,
    appDownoloadKey: "jssp",
    appDownloadLink: "https://www.anygate.vip/r/checkdevice?host=jssp.tv",

  },

  {
    site: "iyf.tv",
    title: "爱壹帆",
    siteKey: "iyf.tv",
    enableAndroidDownload: true,
    enableIOSDonwload: true,
    enableContact: true,
    hidecinema: 0,
    hideAds: false,
    copyRight: "葡萄牙 里斯本 1600-093 Bairro do Rego",
    enableServerDownloadUrl: true,
    appDownoloadKey: "iyf",
    appDownloadLink: "https://www.anygate.vip/r/checkdevice?host=iyf.tv",
    tvApkLink:"https://app.anygate.vip/static/iyf/achived/2.1.14.apk",

  }
  ],
  allowHost:
    [
      "yfsp.tv",
      "yifan.tv",
      "yfsp.me",
      "ayf.tv",
      "aiyifan.tv",
      "wyav.tv",
      "flyv.tv",
      "jssp.tv",
      "iyf.tv",
      "lgsp.tv"
    ]

};
